import { useMemo } from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { getDemoSyncedAt, getLatestDate } from "@helpers/accountSyncTimes";
import { useIsDemoUser } from "./useIsDemoUser";

function useLatestSyncTime(
    accounts: Array<FinancialAccount | IntegrationAccount>,
    key: "balanceSyncedAt" | "transactionsSyncedAt",
) {
    const isDemoUser = useIsDemoUser();
    return useMemo(() => {
        if (isDemoUser) {
            return getDemoSyncedAt();
        }

        return getLatestDate(accounts.map((account) => account[key]));
    }, [accounts, isDemoUser, key]);
}

export function useLatestBalanceSyncTime(
    accounts: Array<FinancialAccount | IntegrationAccount>,
) {
    return useLatestSyncTime(accounts, "balanceSyncedAt");
}

export function useLatestTransactionsSyncTime(
    accounts: Array<FinancialAccount | IntegrationAccount>,
) {
    return useLatestSyncTime(accounts, "transactionsSyncedAt");
}
